<script setup lang="ts">
import { getCurrentInstance } from 'vue';

import TheSlider from '@/components/mode-list/TheSlider.vue';
import { i18n } from '@/shared-instance';

i18n.install(getCurrentInstance()!.appContext.app);
</script>

<template>
  <TheSlider />
</template>
